export const EMAIL_SELECT_MESSAGE_TEMPLATE_STATE = 'EMAIL_SELECT_MESSAGE_TEMPLATE_STATE';
export const EMAIL_SELECT_CANDIDATE_EMAILS = 'EMAIL_SELECT_CANDIDATE_EMAILS';
export const EMAIL_SUMMARY_TEMPLATE_STATE = 'EMAIL_SUMMARY_TEMPLATE_STATE';
